import React, { useState, useEffect } from 'react'
import BatchShipFilter from './Filters/BatchShipFilter'
import BatchShipTable from './BatchShipTable'
import { Spin, Pagination, message } from 'antd'
import Button from "reactstrap/es/Button"
import { Link } from 'react-router-dom'
import UseDebounce from '../helpers/UseDebounce'
import moment from 'moment'
import { getListBatchShip, exportBatchShip, countFbaBatchPendingGenLabel } from '../../../services/api/apiBatchShip'
import CreateMultiBoxHW from './bulkActions/CreateMultiBoxHW'
import listLineShipBox from '../../helpers/listLineShipBox'
import {createJobExport} from '../../helpers/createJobExport'
import downloadFileFromData from '../../helpers/downloadFileFromData'

function BatchShipPage() {
    const [listBatchShip, setListBatchShip] = useState('')
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [status, setStatus] = useState('')
    const [shippingStatus, setShippingStatus] = useState('')
    const [itemType, setItemType] = useState('')
    const [boxCarrier, setBoxCarrier] = useState('')
    const [batch, setBatch] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const [createdStart, setCreatedStart] = useState('')
    const [createdEnd, setCreatedEnd] = useState('')
    const [tracking, setTracking] = useState('')
    const [limit, setLimit] = useState(20)
    const [total, setTotal] = useState(0)
    const [partnerBoxStatus, setPartnerBoxStatus] = useState('')
    // FAC-26443: filter label thùng đang tạm ẩn, giữ state/handler để mở lại (xem buildFilterPayload, BatchShipFilter)
    const [labelStatus, setLabelStatus] = useState('')
    const [isFBA, setIsFBA] = useState(false)
    const [arrSelected, setArrSelected] = useState([])
    const [selectAll, setSelectAll] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [isShowModal, setIsShowModal] = useState(false)
    // Số lô FBA có thùng đủ thông tin chờ gen label (chưa gen) — cảnh báo trên header
    const [fbaPendingGenTotal, setFbaPendingGenTotal] = useState(0)
    // Bật filter chỉ hiện đúng tập "lô FBA chờ gen label" (khớp số đếm) khi click vào text cảnh báo
    const [fbaPendingGenFilter, setFbaPendingGenFilter] = useState(false)

    // Build payload filter dùng chung cho cả danh sách & export (tránh lặp code)
    const buildFilterPayload = () => {
        const payload = {
            page,
            limit,
        }
        if (fbaPendingGenFilter) {
            // Chế độ "lô FBA chờ gen label": chỉ gửi cờ này, bỏ qua filter khác để khớp con số đếm
            payload.fba_pending_gen_label = true
        } else {
            if (status) payload.status = status
            if (shippingStatus) payload.shipping_status = shippingStatus
            if (boxCarrier) payload.box_carrier = boxCarrier
            if (batch.length) payload.item_code = batch
            if (itemType) payload.item_type = itemType
            if (createdStart && createdEnd) payload.created_at = {
                from: createdStart,
                to: createdEnd,
            }
            if (tracking !== '') {
                payload.order_not_pickup_by_shipper = tracking
            }
            if (partnerBoxStatus) payload.partner_box_status = partnerBoxStatus
            // FAC-26443: BE chưa hỗ trợ label_status, tạm không gửi
            // if (labelStatus) payload.label_status = labelStatus
            if (isFBA) payload.batch_type = 'FBA'
        }
        return payload
    }

    const fetchBatchShip = async () => {
        setLoading(true)
        const payload = buildFilterPayload()

        try {
            const { data, success, message: mess } = await getListBatchShip({ ...payload })
            if (success) {
                const { total, batchShips } = data
                setListBatchShip(batchShips)
                setTotal(total)
            } else {
                message.error(mess)
            }

            setLoading(false)
        } catch (error) {
            message.error(error.message || 'Unknown error.')
        } finally {
            setLoading(false)
        }

    }

    const debounceSearch = UseDebounce(batch, 1000)

    const handlePageChange = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const handleChangeStatus = (value) => {
        setFbaPendingGenFilter(false)
        setStatus(value)
        setPage(1)
    }

    const handleChangeShippingStatus = (value) => {
        setFbaPendingGenFilter(false)
        setShippingStatus(value)
        setPage(1)
    }

    const handleChangeItemType = (value) => {
        setFbaPendingGenFilter(false)
        setItemType(value)
        setPage(1)
    }

    const handleChangeBoxCarrier = (value) => {
        setFbaPendingGenFilter(false)
        setBoxCarrier(value)
        setPage(1)
    }

    const handleChangeTracking = (value) => {
        setFbaPendingGenFilter(false)
        setTracking(value)
        setPage(1)
    }

    const handleChangeBatch = (value) => {
        setFbaPendingGenFilter(false)
        setSearchValue('')
        const Value = [...new Set(value.filter(i => !!i && i).map(i => i.replace(/#|'|_\d+/g, "")))]
        setBatch(Value)
        setPage(1)
    }
    const handleSearchBatch = (value) => {
        if (value.includes(',') || value.includes(' ')) {
            setSearchValue('')
            const Value = [...new Set(value.replace(/ |#|'|_\d+/g, ",").split(',').map(i => i.trim()).filter(i => !!i && !batch.includes(i) && i))]
            setBatch([...batch, ...Value])
        } else {
            setSearchValue(value)
        }
    }

    const handleChangeCreated = (momentArray, dateStringArray) => {
        setFbaPendingGenFilter(false)
        setCreatedStart(dateStringArray[0])
        setCreatedEnd(dateStringArray[1])
        setPage(1)
    }

    const handleChangePartnerBoxStatus = (value) => {
        setFbaPendingGenFilter(false)
        setPartnerBoxStatus(value)
        setPage(1)
    }

    const handleChangeLabelStatus = (value) => {
        setFbaPendingGenFilter(false)
        setLabelStatus(value)
        setPage(1)
    }

    const handleChangeIsFBA = (checked) => {
        setFbaPendingGenFilter(false)
        setIsFBA(checked)
        setPage(1)
    }

    // Filter "FBA chờ gen label": bật thì lọc đúng tập lô của con số đếm (bỏ filter khác để số khớp)
    const handleChangeFbaPendingGen = (checked) => {
        setFbaPendingGenFilter(checked)
        setPage(1)
    }

    const toggleOpenBuklAction = () => {
        setIsOpen(!isOpen)
    }

    const _handleToggleModal = () => {
        if(isShowModal === true){
            setIsOpen(false)
        }
        
        setIsShowModal(!isShowModal)
    }

    const _updateSelectedSku = (id, isAdded) => {
        // const itemsCanChecked = listBatchShip.filter(item => item)
        if (isAdded && !arrSelected.map(i => i._id).includes(id)) {
            const newSelected = [...arrSelected, ...listBatchShip.filter(i => i._id === id)]
            setArrSelected(newSelected)
            const selectAllNew = arrSelected.length + 1 === listBatchShip.length ? true : false
            setSelectAll(selectAllNew)
        } else {
            const filtered = arrSelected.filter(item => item._id !== id)

            setArrSelected(filtered)
            setSelectAll(false)
            if(filtered.length === 0){
                setIsOpen(false)
            }
        }
    }

    const _handleCheckALl = (isChecked) => {
        if (isChecked) {
            const batchShipItems = [...listBatchShip].map(item => item)
            setArrSelected(batchShipItems)
            setSelectAll(true)
        }else{
            setArrSelected([])
            setSelectAll(false)
            setIsOpen(false)
        }
    }

    const handleExportBatch = async() => {
        try {
            const payload = buildFilterPayload()

            const { data: res } = await exportBatchShip(payload)
            if (typeof res !== "string") {
                const { success, message: mess, data } = res

                if (!success) throw new Error(mess)
                if (Object.keys(data).length > 0) createJobExport(data)
            } else {
                downloadFileFromData(res, { filename: `BatchShip-${moment().format('YYYY-MM-DD')}.csv` })
            }
        } catch (error) {
            message.error(error.message)
        }

    }

    const fetchFbaPendingGenLabel = async () => {
        try {
            const { data: res } = await countFbaBatchPendingGenLabel()
            const { success, data } = { ...res }
            if (success) setFbaPendingGenTotal((data && data.total) || 0)
        } catch (e) {
            // Không chặn màn hình nếu API cảnh báo lỗi
        }
    }

    useEffect(() => {
        fetchFbaPendingGenLabel()
    }, [])

    useEffect(() => {
        fetchBatchShip()
        _handleCheckALl(false)
    }, [
        status, shippingStatus, boxCarrier, itemType, tracking,
        debounceSearch, createdStart, createdEnd, limit, page, partnerBoxStatus, labelStatus, isFBA, fbaPendingGenFilter
    ])

    return (
        <div className='BatchShipPage'>
            <div className='PageHeading d-flex align-items-center justify-content-between border-bottom'>
                <h1 className="PageTitle font-weight-bold mb-0">Quản lý lô ship</h1>
                <div className="RightTop">
                    <button
                        className='btn btn-primary mb-2 mx-1'
                        style={{ background: '#4A80F7' }}
                        onClick={handleExportBatch}
                    >
                        <i className="fa fa-download mr-1"/>Export lô ship
                    </button>
                    <Link to={`/batch-ship/create`} className='btn btn-primary mb-2' style={{ background: '#477BF6' }}>
                        <i className="fa fa-plus mr-1"/>Tạo lô ship
                    </Link>
                </div>
            </div>
            <div className="SectionInner mt-3 card px-3 py-3">
                <div className="filter align-items-center mt-2">
                    <BatchShipFilter
                        status={status}
                        shippingStatus={shippingStatus}
                        boxCarrier={boxCarrier}
                        batch={batch}
                        itemType={itemType}
                        createdStart={createdStart}
                        createdEnd={createdEnd}
                        tracking={tracking}
                        searchValue={searchValue}
                        loading={loading}
                        handleChangeCreated={handleChangeCreated}
                        handleChangeStatus={handleChangeStatus}
                        handleChangeShippingStatus={handleChangeShippingStatus}
                        handleChangeBatch={handleChangeBatch}
                        handleChangeBoxCarrier={handleChangeBoxCarrier}
                        handleChangeItemType={handleChangeItemType}
                        handleChangeTracking={handleChangeTracking}
                        handleSearchBatch={handleSearchBatch}
                        partnerBoxStatus={partnerBoxStatus}
                        handleChangePartnerBoxStatus={handleChangePartnerBoxStatus}
                        labelStatus={labelStatus}
                        handleChangeLabelStatus={handleChangeLabelStatus}
                        isFBA={isFBA}
                        handleChangeIsFBA={handleChangeIsFBA}
                        fbaPendingGen={fbaPendingGenFilter}
                        handleChangeFbaPendingGen={handleChangeFbaPendingGen}
                    />
                </div>
                {
                    <div>
                        <div className='SkuTotal d-flex justify-content-between align-items-center mb-3'>
                            <div className='d-flex align-content-center'>
                                {
                                    !!arrSelected.length && status === 'confirmed' && listLineShipBox.includes(boxCarrier) &&
                                    <div className='d-flex align-items-center'>
                                        <div className="CustomSelect">
                                            <Button onClick={toggleOpenBuklAction}
                                                    className="dropdown-toggle" disabled={arrSelected.length === 0}>Hành động</Button>
                                            <div className={isOpen ? 'ListAction open' : 'ListAction'}>
                                                <Button color="link" className="mr-1"
                                                        onClick={_handleToggleModal}>Tạo thùng HW</Button>
                                                <CreateMultiBoxHW 
                                                    onRefresh={fetchBatchShip}
                                                    visible={isShowModal}
                                                    onCancel={_handleToggleModal}
                                                    selectedItems={arrSelected}
                                                    setSelectedItems={(i) => setArrSelected(i)}
                                                    reload={fetchBatchShip}
                                                    />
                                            </div>
                                            {
                                                // isOpen && <div className="Background" onClick={toggleOpenBuklAction}/>
                                            }
                                        </div>
                                        <div className='ml-2'>
                                            Đã chọn <strong>
                                                {arrSelected.length}</strong> lô
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className='d-flex align-items-center' style={{ gap: '24px' }}>
                                {/* Cảnh báo lô FBA chờ gen label — click để lọc FBA + Chưa có label */}
                                {!!fbaPendingGenTotal &&
                                    <div
                                        className='font-weight-bold'
                                        style={{ cursor: 'pointer', color: fbaPendingGenFilter ? '#a71d2a' : '#dc3545' }}
                                        onClick={() => handleChangeFbaPendingGen(true)}
                                    >
                                        {fbaPendingGenTotal} lô FBA chờ gen label
                                    </div>
                                }
                                {
                                    total > 0 && <div>
                                        <span>{total}</span> items
                                    </div>
                                }
                            </div>
                        </div>
                        <Spin spinning={loading} tip='Data Loading...'>
                            <BatchShipTable
                                selectAll={selectAll}
                                arrSelected={arrSelected}
                                listBatchShip={listBatchShip}
                                loading={loading}
                                reload={fetchBatchShip}
                                onCheckALl={_handleCheckALl}
                                onSelected={_updateSelectedSku}
                                status={status}
                                boxCarrier={boxCarrier}
                            />
                            <Pagination
                                pageSizeOptions={['10', '20', '50', '100']}
                                onChange={handlePageChange}
                                className='text-right'
                                pageSize={limit}
                                showSizeChanger
                                current={page}
                                total={total}
                            />
                        </Spin>
                    </div>
                }
            </div>
        </div>
    )
}

export default BatchShipPage